module.exports = __webpack_public_path__ + "static/media/404.e6e8b708.svg";